module.exports = new __parcel__URL__("arrow-left.2b7bce11.svg").toString();